import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { CheckedIcon } from '../../assets/CheckedIcon';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
const BOLD_FONT_WEIGHT = 600;
export const Step = styled('div', {
    position: 'relative',
    textAlign: 'center',
    flex: 1,
});
const StepLine = styled('div', {
    position: 'absolute',
    top: `calc(${sizes.stepper.icon.size}/2)`,
    left: `calc(50% + ${sizes.stepper.icon.size}/2)`,
    width: `calc(100% - ${sizes.stepper.icon.size})`,
    borderWidth: sizes.stepper.stepLine.borderWidth,
    borderStyle: 'solid',
    borderColor: staticColors.stepperLine,
});
const StyledStepInnerCircle = styled('div', (p) => ({
    height: sizes.stepper.innerCircle.size,
    width: sizes.stepper.innerCircle.size,
    borderRadius: '50%',
    backgroundColor: p.$isActive
        ? staticColors.stepperActiveStepBackground
        : 'none',
}));
const StyledStepOuterCircle = styled('div', (p) => ({
    height: sizes.stepper.outerCircle.size,
    width: sizes.stepper.outerCircle.size,
    borderWidth: sizes.stepper.outerCircle.borderWidth,
    borderStyle: 'solid',
    borderColor: p.$isActive
        ? staticColors.stepperActiveStepBackground
        : staticColors.stepperStepBorder,
    borderRadius: '50%',
    backgroundColor: staticColors.stepperInactiveStepBackground,
}));
const StyledRadioCheckedIcon = styled('div', {
    height: sizes.stepper.icon.size,
    width: sizes.stepper.icon.size,
    borderRadius: '50%',
    margin: `auto`,
    backgroundColor: staticColors.stepperDoneStepBackground,
});
const StepCircle = ({ isActive }) => (_jsx(FlexContainer, { center: true, children: _jsx(StyledStepOuterCircle, { $isActive: isActive, children: _jsx(FlexContainer, { center: true, fullHeight: true, children: _jsx(StyledStepInnerCircle, { $isActive: isActive }) }) }) }));
const getStepSymbol = (isActive, isDone) => {
    if (isActive)
        return _jsx(StepCircle, { isActive: true });
    if (isDone)
        return (_jsx(StyledRadioCheckedIcon, { children: _jsx(CheckedIcon, {}) }));
    return _jsx(StepCircle, { isActive: false });
};
export const Stepper = ({ steps, activeStepIndex }) => {
    return (_jsx(FlexContainer, { fullWidth: true, children: steps.map((label, index) => {
            const isActive = activeStepIndex === index;
            const isDone = activeStepIndex > index;
            const isStepLineVisible = index < steps.length - 1;
            const maybeStepLine = isStepLineVisible && _jsx(StepLine, {});
            const stepSymbol = getStepSymbol(isActive, isDone);
            const activeFontWeight = isActive ? BOLD_FONT_WEIGHT : undefined;
            return (_jsxs(Step, { children: [_jsx(Box, { spacingBottom: true, children: stepSymbol }), _jsx(Text, { variant: 'b2', color: 'dark', fontWeightOverride: activeFontWeight, children: label }), maybeStepLine] }, index));
        }) }));
};
